document.addEventListener("DOMContentLoaded", () => {

    function fireFilterEngine() {
        console.log("Refiring filter engine...");

        if (typeof applyFilters === "function") {
            applyFilters();
        }
    }

    function rebuildProductArray() {
        window.AGC_ProductArray = [];
        document.querySelectorAll(".agc-product").forEach(el => {
            const id = el.dataset.productId;
            const data = window.AGC_Products[id];
            if (data) window.AGC_ProductArray.push(data);
        });
        console.log("Rebuilt meta array:", window.AGC_ProductArray);
    }

    // 1️⃣ Filters changed
    document.addEventListener("change", evt => {
        if (evt.target.closest(".filter__content")) {
            console.log("Filter inputs changed");
            fireFilterEngine();
        }
    });

    // 2️⃣ Collection updated by Shopify AJAX
    const target = document.querySelector("#filter-results");

    if (target) {
        const observer = new MutationObserver((mutations) => {
            console.log("Collection mutated -> AJAX reload detected");
            rebuildProductArray();
            fireFilterEngine();
        });
        observer.observe(target, { childList: true, subtree: true });
    }
});